var alp_wptravel = {};

(function($) {
    $(window).load(function() {
        $('#loading').hide();
        if (typeof wp_travel_cart !== 'undefined') {
          wp_travel_cart.timeout(fetch("".concat(wp_travel.ajaxUrl, "?action=wp_travel_get_cart&_nonce=").concat(wp_travel._nonce)).then(function (res) {
            res.json().then(function (result){
              $('#loader').show();
              if (result.success && result.data.code === 'WP_TRAVEL_CART') {
                if (result.data.cart) {
                  wp_travel_cart.cart = result.data.cart;
                  Object.freeze(wp_travel_cart.cart);
                }
                console.log(wp_travel_cart.cart.cart_items);
                $('#loader').hide();
                var checkBox1 = $("#chck1");
                var checkBox2 = $("#chck2");
                for (var key in wp_travel_cart.cart.cart_items) {
                  console.log(parseInt(wp_travel_cart.cart.cart_items[key].step_section));
                  if(parseInt(wp_travel_cart.cart.cart_items[key].step_section) == 1){
                    checkBox1.prop("checked", false);
                    checkBox2.prop("checked", true);
                    alp_wptravel.step1 = 'done';
                    $('html, body').animate({
                      scrollTop: $("#chck1").length ? $("#chck1").offset().top+50 : 0
                    }, 2000);
                  }
                }
              }
            });
          }), 10000)["catch"](function (error) {
              alert('[X] Request Timeout!');
              $('#loader').hide();
          });
        }
      });
})(jQuery);

var showCartLoader = function showCartLoader(on) {
  if (on) {
    cartLoader.removeAttribute('style');
  } else {
    cartLoader.style.display = 'none';
  }
}; // let cart = {}

var cartLoader = document.querySelector('.wp-travel-cart-loader');

//cartLoader && showCartLoader(true);

jQuery(function ($) {
  var fx = function fx() {
  $(".stat-number").each(function (i, el) {
      var data = parseInt(this.dataset.n, 10);
      var props = {
          "from": {
              "count": 0
          },
              "to": { 
              "count": data
          }
      };
      $(props.from).animate(props.to, {
          duration: 1000 * 1,
          step: function (now, fx) {
              $(el).text(Math.ceil(now));
          },
          complete:function() {
              if (el.dataset.sym !== undefined) {
                el.textContent = el.textContent.concat(el.dataset.sym)
              }
          }
      });
  });
  };
  if($('.cat-mobile-display:visible').length > 0){
      var cat_menu_section = $('.blogs-categories-display').position().top;
    $(window).scroll(function() {
      console.log('section: ', cat_menu_section);
      console.log('top: ', $(window).scrollTop());
      if ($(window).scrollTop() > cat_menu_section){
        $('.blogs-categories-display').addClass('make-sticky');
      }else{
        $('.blogs-categories-display').removeClass('make-sticky');
      }
    });
  }
 

  if($('.cat-mobile-display:visible').length == 0){
    var reset = function reset() {
        //console.log($(this).scrollTop())
        if ($(this).scrollTop() > 90) {
            $(this).off("scroll");
          fx()
        }
    };
    $(window).on("scroll", reset);
  } 
});
jQuery(document).ready(function($){
  $('#genesis-mobile-nav-primary').on('click', function(e){
    e.preventDefault();
    $(this).toggleClass('activated');
    $('#genesis-nav-primary').slideToggle( 'fast' );
  });
  if($('.type-post').length){
    $(".clearfix").nextAll("h2:first").css({'margin-top':'0px'});
  }
  if($('.cat-mobile-display:visible').length > 0){
      $('ul.categories').css({'--caret-left': ($('.selected-category > .fas').position().left - ($('.selected-category > .fas').width() - 2)) + 'px'});
      //console.log('show');
      $(document).on('click', '.selected-category', function(e){
        e.preventDefault();
        $(this).parent().parent().find('.categories').toggleClass('screen-hide-section');
      });
  }
});
jQuery(window).load(function(){
  var _sliderbanner = false;
  if(jQuery('#sliderbanner').length){
    _sliderbanner = true;
  }
    var BannerSwiperConfig = {
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      }
      if(_sliderbanner){
        var attr = jQuery('.swiper-container').attr('data-swiper-autoplay');
        if (typeof attr !== typeof undefined && attr !== false) {
          var AutoSlideConfig = {
            autoplay: {
              delay: jQuery('.swiper-container').attr('data-swiper-autoplay'),
            },
          }
          jQuery.extend(BannerSwiperConfig, AutoSlideConfig);
        }
      }
    var windowsize = jQuery(window).width();
    if(windowsize < '769'){
      if(_sliderbanner){
        setTimeout(function() { 
          jQuery('.banner-slides-wrapper').css({'visibility':'visible'});
          jQuery('#columns2content').find('.headline-wrapper').css({'visibility':'visible'});
          var BannerSwiper = new Swiper('.swiper-container', BannerSwiperConfig );
        }, 500);
      }
    }else{
      jQuery('#genesis-nav-primary').show();
      if(_sliderbanner){
        setTimeout(function() { 
          jQuery('.banner-slides-wrapper').css({'visibility':'visible'});
          jQuery('#columns2content').find('.headline-wrapper').css({'visibility':'visible'});
          var BannerSwiper = new Swiper('.swiper-container', BannerSwiperConfig );
        }, 500);
      }
    }
    jQuery(window).resize(function(){
      var windowsize = jQuery(window).width();
      if(windowsize < 769){
        jQuery('#genesis-nav-primary').hide();
        if(_sliderbanner){
          setTimeout(function() { 
            jQuery('.banner-slides-wrapper').css({'visibility':'visible'});
            jQuery('#columns2content').find('.headline-wrapper').css({'visibility':'visible'});
            var BannerSwiper = new Swiper('.swiper-container', BannerSwiperConfig );
          }, 500);
        }
      }else{
        jQuery('#genesis-nav-primary').show();
        if(_sliderbanner){
          setTimeout(function() { 
            jQuery('.banner-slides-wrapper').css({'visibility':'visible'});
            jQuery('#columns2content').find('.headline-wrapper').css({'visibility':'visible'});
            var BannerSwiper = new Swiper('.swiper-container', BannerSwiperConfig );
          }, 500);
        }
      }
    });
});

  var TestimonialSwiper = new Swiper('.testimonials-wrapper', {
    // Optional parameters
    slidesPerView: 3,
    slidesPerGroup: 3,
    spaceBetween: 30,
    loop: false,
    // Navigation arrows
    navigation: {
      nextEl: '.testimonial-button-next',
      prevEl: '.testimonial-button-prev',
    },
    breakpoints: {
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        375: {
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        425: {
            slidesPerView: 1,
            slidesPerGroup: 1,
        },
        768: {
            slidesPerView: 2,
            spaceBetween: 30,
            slidesPerGroup: 2,
        },
        769:{
          slidesPerView: 3,
          slidesPerGroup: 3,
          spaceBetween: 30,
        }
    }
  });

  var galleryThumbs = new Swiper('.gallery-thumbs', {
    spaceBetween: 10,
    slidesPerView: 4,
    loop: true,
    freeMode: true,
    loopedSlides: 5, //looped slides should be the same
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  
  var galleryTop = new Swiper('.gallery-top', {
    spaceBetween: 10,
    loop: true,
    loopedSlides: 5, //looped slides should be the same
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: galleryThumbs,
    },
  });
  
jQuery(document).ready(function($){
  $('.expand-all .btn').on('click', function(){
      //$(this).find('i').toggleClass('ebs-icon-minus ebs-icon-plus');
      console.log($(this).text());
      var checkBoxes = $(".tabs input[type=checkbox]");
      if($(this).text().trim() == 'Expand All'){
        $(this).html('<i class="ebs-icon ebs-icon-minus"></i>Hide All')
        $(this).find('i').removeClass('ebs-icon-plus');
        $(this).find('i').addClass('ebs-icon-minus');
        checkBoxes.prop("checked", true);
      }else{
        $(this).html('<i class="ebs-icon ebs-icon-plus"></i>Expand All')
        $(this).find('i').removeClass('ebs-icon-minus');
        $(this).find('i').addClass('ebs-icon-plus');
        checkBoxes.prop("checked", false);
      }
  });
  $('.apply-coupon-code').on('click', function(e){
    e.preventDefault();
    if($('.coupon-input-field').val().length <= 0){
      $('.coupon-input-field').css('border','red');
      $('.coupon-input-field').focus();
    }else{
      //toggleCartLoader(true);
      if ( $('.coupon-input-field')[0].hasAttribute('readonly') == false ){
        e.target.disabled = true;
        wp_travel_cart.timeout(fetch("".concat(wp_travel.ajaxUrl, "?action=wp_travel_apply_coupon&_nonce=").concat(wp_travel._nonce), {
          method: 'POST',
          body: JSON.stringify({
            couponCode: $('.coupon-input-field').val()
          })
        }).then(function (res) {
          return res.json();
        }).then(function (result) {
          //toggleCartLoader();

          if (result.success) {
            wp_travel_cart.cart = result.data.cart;
            $('.coupon-input-field').prop("readonly", true);
            e.target.innerHTML = e.target.dataset.successL10n;
            e.target.style.backgroundColor = 'green';
            /*shoppingCart.dispatchEvent(new CustomEvent('wptcartchange', {
              detail: {
                coupon: result.data.cart.coupon
              }
            }));*/
            //alps_updateCart();
            if (result.data.cart) {
              wp_travel_cart.cart = result.data.cart;
              Object.freeze(wp_travel_cart.cart);
            }
            alps_updateCart();
            for (var key in wp_travel_cart.cart.cart_items) {
              wp_travel_cart.cart.cart_items[key].step_section =0;
            }
            location.reload();
          } else {
            $('.coupon-input-field').focus();
            toggleError($('.coupon-input-field'), result.data[0].message);
            e.target.disabled = false;
          }
        }), 10000)["catch"](function (error) {
          alert('[X] Request Timeout!');
          //toggleCartLoader();
        });
      }
    }
  });

  $('.reserved-btn').on('click', function(){
    if ($(window).width() <= 768) {
      $([document.documentElement, document.body]).animate({
            scrollTop: $("#oviewrightcontent").offset().top
      }, 2000);
    }else{
      $([document.documentElement, document.body]).animate({
          scrollTop: $("#oviewrightcontent").offset().top-120
      }, 2000);
    }
  });
  $('.booknow-btn').on('click', function(){
    //alert(wp_travel.ajaxUrl);
    //alert(_wp_travel._nonce);
    var getKeys = function(obj){
      var keys = [];
      for(var key in obj){
        keys.push(key);
      }
      return keys;
    }
    console.log(getKeys(_wp_travel));
    console.log(_wp_travel.trip_data);
    var pt = _wp_travel.trip_data.pricings;
    console.log(pt);
    var trip_price = 0;
    if(_wp_travel.trip_data.pricings[0].categories[0].is_sale){
      trip_price = _wp_travel.trip_data.pricings[0].categories[0].sale_price;
    }else{
      trip_price = _wp_travel.trip_data.pricings[0].categories[0].regular_price;
    }
    var pax = {};
    pax[_wp_travel.trip_data.pricings[0].categories[0].id] = _wp_travel.trip_data.pricings[0].min_pax;
    $.ajax({ 
      "contentType": "application/json", 
      data:JSON.stringify({
        "trip_id":_wp_travel.trip_data.id,
        "arrival_date":_wp_travel.trip_data.dates[0].start_date,
        "pricing_id":_wp_travel.trip_data.pricings[0].id,
        "pax":pax,
        "category_pax":pax,
        "trip_price":trip_price,
        "trip_time":"00:00"
      }),
      type: 'POST',
      url: "".concat(wp_travel.ajaxUrl, "?action=wp_travel_add_to_cart&_nonce=").concat(_wp_travel._nonce),
      success: function(response){
        console.log('success');
        console.log(response);
        !0 === response.success && "WP_TRAVEL_ADDED_TO_CART" === response.data.code && (wp_travel.isEnabledCartPage ? location.href = wp_travel.cartUrl : location.href = wp_travel.checkoutUrl)
      },
      error: function(response){
          console.log('error');
          console.log(response);
      }
    });
  });

  $('#contbooking1').on('click', function(e){
    e.preventDefault();
    alps_updateCart();
    //data-cart-id
    var update_cart_fields = {};
      // pax = $(this).find('input[name="pax^"]').val();
      var cart_id = alp_wptravel.cart_id;
      var pricing_id = alp_wptravel.pricing_id;
      var pax = alp_wptravel.pax;

      var wp_travel_trip_extras = {};
      wp_travel_trip_extras['id'] = {};
      wp_travel_trip_extras['qty'] = {}
      var _data = {
        pax: pax,
        wp_travel_trip_extras: {
          id: {},
          qty: {}
        },
        pricing_id:pricing_id,
        step_section:1
      };
      if(wp_travel_cart.cart.coupon.hasOwnProperty('type')){
        console.log('coupon continue booking: ' + wp_travel_cart.cart.coupon.value);
        var x_checkBox1 = $("#chck1");
        var x_checkBox2 = $("#chck2");
        for (var key in wp_travel_cart.cart.cart_items) {
          wp_travel_cart.cart.cart_items[key].step_section = 1;
          if(parseInt(wp_travel_cart.cart.cart_items[key].step_section) == 1){
            x_checkBox1.prop("checked", false);
            x_checkBox2.prop("checked", true);
            alp_wptravel.step1 = 'done';
            $('.tab .tab-label .num1').removeClass('done').addClass('done');
            $('html, body').animate({
              scrollTop: $("#chck1").length ? $("#chck1").offset().top+50 : 0
            }, 2000);
          }
        }
      }else{
      //todo: Disable booking buttom while submit is on process
      $.ajax({
        "contentType": "application/json",
        type: "POST",
        url: "".concat(wp_travel.ajaxUrl, "?action=wp_travel_update_cart_item&cart_id=").concat(cart_id, "&_nonce=").concat(wp_travel._nonce),
        data:JSON.stringify(_data),
        beforeSend: function beforeSend() {},
        success: function success(response) {
          if(response.success && "WP_TRAVEL_CART_ITEM_UPDATED" === response.data.code){
            //location.reload();
            wp_travel_cart.timeout(fetch("".concat(wp_travel.ajaxUrl, "?action=wp_travel_get_cart&_nonce=").concat(wp_travel._nonce)).then(function (res) {
                res.json().then(function (result) {
                  if (result.success && result.data.code === 'WP_TRAVEL_CART') {
                    if (result.data.cart) {
                      wp_travel_cart.cart = result.data.cart;
                      Object.freeze(wp_travel_cart.cart);
                    }
                    console.log(wp_travel_cart.cart.cart_items);
                    location.reload();
                  }
                });
            }), 10000)["catch"](function (error) {
                alert('[X] Request Timeout!');
                $('#loader').hide();
            });
          }
        }
      });
    }
  });

  if($('.btn-info-simple-text').length){
    $(document).on('click','.btn-info-simple-text',function(e){
      e.preventDefault();
      var poneno = $('#phoneno').val();
      var $el = this;
      $($el).parent().find('.phone-number').hide();
      $($el).parent().find('.btn-info').hide();
      if($('.btn-info-simple-text .notify').length){
        $($el).parent().find('.notify').html('Processing...');
      }else{
        $($el).parent().append('<span class="notify" style="width: 100%;padding: 5px 10px;background: #020206;color: #fff;text-align: center;">Processing...</span>');
      }
      $.ajax({ 
        data: {action: 'simple_text_add', phoneno:poneno, security: ajax_object.ajax_nonce},
        type: 'post',
        url: ajax_object.ajaxurl,
        success: function(data) {
          var res = JSON.parse(data);
          console.log(res);
          //console.log(res.id); //should print out the name since you sent it along
          if(res.hasOwnProperty('id')){
            $($el).parent().find('.notify').html("Yay! We'll text you about yoga & community events!");
            setTimeout(function() { 
              $($el).parent().find('.phone-number').show();
              $($el).parent().find('.phone-number').val('');
              $($el).parent().find('.btn-info').show();
              $($el).parent().find('.notify').hide();
            }, 3000);
          }
          if(res.hasOwnProperty('message')){
            $($el).parent().find('.notify').html(res.message);
            setTimeout(function() { 
              $($el).parent().find('.phone-number').show();
              $($el).parent().find('.btn-info').show();
              $($el).parent().find('.notify').hide();
            }, 3000);
          }
       }
   });
    });
  }

  $('#contbooking2').on('click', function(e) {
    e.preventDefault();
    var has_error = false;
    var checkBox1 = $("#chck1");
    var checkBox2 = $("#chck2");
    var checkBox3 = $("#chck3");
    
    if(!alp_wptravel.hasOwnProperty('step1')){
      checkBox1.prop("checked", true);
      alert('Please confirm your booking details.');
      $('html, body').animate({
        scrollTop: $("#chck1").offset().top
      }, 2000);
      return;
    }

    $('.traveller-info [data-parsley-required="1"]').each(function(){
      console.log($(this).attr('id')+' '+($(this).val().trim() != ''));
      var valid_field = $('#'+$(this).attr('id')).parsley();
      console.log(valid_field.isValid());
      console.log(valid_field.getErrorsMessages()[0]);
        if(!valid_field.isValid()){
          has_error = true;
          $(this).next().remove('.parsley-errors-list');
          $(this).after('<ul class="parsley-errors-list filled" id="parsley-id-18" aria-hidden="false"><li class="parsley-required">'+valid_field.getErrorsMessages()[0]+'</li></ul>');
        }else{
          $(this).next().remove('.parsley-errors-list');
        }
      });
      if(has_error){
        $('html, body').animate({
          scrollTop: $("#chck1").offset().top+50
        }, 2000);
      }else{
        checkBox1.prop("checked", false);
        checkBox2.prop("checked", false);
        checkBox3.prop("checked", true);
        $('html, body').animate({
          scrollTop: $("#chck1").offset().top+150
        }, 500);
        alp_wptravel.step2 = 'done';
        if($('.traveller-info .tab-label .num2').hasClass('done')){
          $('.traveller-info .tab-label .num2').removeClass('done').addClass('done');
        }else{
          $('.traveller-info .tab-label .num2').addClass('done');
        }
      }
  });

  $('#contbooking3').on('click', function(e) {
    e.preventDefault();
    var has_error = false;
    var checkBox1 = $("#chck1");
    var checkBox2 = $("#chck2");
    var checkBox3 = $("#chck3");
    var checkBox4 = $("#chck4");
    if(!alp_wptravel.hasOwnProperty('step1')){
      checkBox1.prop("checked", true);
      alert('Please confirm your booking details.');
      $('html, body').animate({
        scrollTop: $("#chck1").offset().top
      }, 2000);
      return;
    }
    if(!alp_wptravel.hasOwnProperty('step2')){
      $('.traveller-info [data-parsley-required="1"]').each(function(){
        var valid_field = $('#'+$(this).attr('id')).parsley();
        console.log(valid_field.isValid());
        console.log(valid_field.getErrorsMessages()[0]);
          if(!valid_field.isValid()){
            has_error = true;
            $(this).next().remove('.parsley-errors-list');
            $(this).after('<ul class="parsley-errors-list filled" id="parsley-id-18" aria-hidden="false"><li class="parsley-required">'+valid_field.getErrorsMessages()[0]+'</li></ul>');
          }else{
            $(this).next().remove('.parsley-errors-list');
          }
        });
      checkBox2.prop("checked", true);
      $('html, body').animate({
        scrollTop: $("#chck1").offset().top+100
      }, 2000);
      return;
    }

    $('.billing-info [data-parsley-required="1"]').each(function(){
      console.log($(this).attr('id')+' '+($(this).val().trim() != ''));
      var valid_field = $('#'+$(this).attr('id')).parsley();
      if(!valid_field.isValid()){
        has_error = true;
        $(this).next().remove('.parsley-errors-list');
        $(this).after('<ul class="parsley-errors-list filled" id="parsley-id-18" aria-hidden="false"><li class="parsley-required">'+valid_field.getErrorsMessages()[0]+'</li></ul>');
      }else{
        $(this).next().remove('.parsley-errors-list');
      }
    });
    if(has_error){
      $('html, body').animate({
        scrollTop: $("#chck1").offset().top+150
      }, 2000);
    }else{
      checkBox1.prop("checked", false);
      checkBox2.prop("checked", false);
      checkBox3.prop("checked", false);
      checkBox4.prop("checked", true);
      $('html, body').animate({
        scrollTop: $("#chck1").offset().top+200
      }, 500);
      alp_wptravel.step3 = 'done';
      if($('.billing-info .tab-label .num3').hasClass('done')){
        $('.billing-info .tab-label .num3').removeClass('done').addClass('done');
      }else{
        $('.billing-info .tab-label .num3').addClass('done');
      }
    }
  });

  $('#contbooking4').on('click', function(e) {
    e.preventDefault();
    var has_error = false;
    var checkBox1 = $("#chck1");
    var checkBox2 = $("#chck2");
    var checkBox3 = $("#chck3");
    if(!alp_wptravel.hasOwnProperty('step1')){
      checkBox1.prop("checked", true);
      alert('Please confirm your booking details.');
      $('html, body').animate({
        scrollTop: $("#chck1").offset().top
      }, 2000);
      return;
    }
    if(!alp_wptravel.hasOwnProperty('step2')){
      $('.traveller-info [data-parsley-required="1"]').each(function(){
        var valid_field = $('#'+$(this).attr('id')).parsley();
          if(!valid_field.isValid()){
            has_error = true;
            $(this).next().remove('.parsley-errors-list');
            $(this).after('<ul class="parsley-errors-list filled" id="parsley-id-18" aria-hidden="false"><li class="parsley-required">'+valid_field.getErrorsMessages()[0]+'</li></ul>');
          }else{
            $(this).next().remove('.parsley-errors-list');
          }
        });
      checkBox2.prop("checked", true);
      $('html, body').animate({
        scrollTop: $("#chck1").offset().top+100
      }, 2000);
      return;
    }
    if(!alp_wptravel.hasOwnProperty('step3')){
      $('.billing-info [data-parsley-required="1"]').each(function(){
        var valid_field = $('#'+$(this).attr('id')).parsley();
          if(!valid_field.isValid()){
            has_error = true;
            $(this).next().remove('.parsley-errors-list');
            $(this).after('<ul class="parsley-errors-list filled" id="parsley-id-18" aria-hidden="false"><li class="parsley-required">'+valid_field.getErrorsMessages()[0]+'</li></ul>');
          }else{
            $(this).next().remove('.parsley-errors-list');
          }
        });
      checkBox3.prop("checked", true);
      $('html, body').animate({
        scrollTop: $("#chck3").offset().top+150
      }, 2000);
      return;
    }
    //$('#loader2').show();
    //$(this).prop('disabled', true);
    $('#wp-travel-book-now').click();
  });

  $('select[name="numofpeople"], select[name="package"]').on('change', function(e){
    alps_updateCart();
  });

  $('#chck1').on('click',function() {
    $('html, body').animate({
      scrollTop: $("#chck1").offset().top
    }, 500);
  });
  $('#chck2').on('click',function() {
    $('html, body').animate({
      scrollTop: $("#chck1").offset().top+100
    }, 500);
  });
  $('#chck3').on('click',function() {
    $('html, body').animate({
      scrollTop: $("#chck1").offset().top+150
    }, 500);
  });
  $('#chck4').on('click',function(e) {
    $('html, body').animate({
      scrollTop: $("#chck1").offset().top+200
    }, 500);

  });

  function alps_updateCart(){
    var numofpeople = $('select[name="numofpeople"]').val();
    var sc_qty = $('.wp-travel-cart-category-qty');
    sc_qty.val(parseInt(numofpeople));
    //shoppingCart.dispatchEvent(new Event('wptcartchange'));
    //var pt = wp_travel.trip_data.pricings;
    var regPrice = 0;
    var cartTotal = 0,
        tripTotalWOExtras = 0,
        txTotal = 0,
        tripTotalPartialWOExtras = 0;
    var cartTotalContainers = document.querySelectorAll('[data-wpt-cart-total]');
    var cartTotalPartialContainers = document.querySelectorAll('[data-wpt-cart-partial-total]');
    var cartSubtotalContainer = document.querySelector('[data-wpt-cart-subtotal]');
    var cartDiscountContainer = document.querySelector('[data-wpt-cart-discount]');
    var cartTaxContainer = document.querySelector('[data-wpt-cart-tax]');
    var item = document.querySelector('[data-cart-id]');
    
    console.log($('select[name="package"]').val());
    var pax = {};
    alp_wptravel.cart_id = item.dataset.cartId;
    alp_wptravel.reg_price = wp_travel_cart.cart.cart_items[item.dataset.cartId].trip_data.pricings[$('select[name="package"]').val()].categories[0].regular_price;
    alp_wptravel.is_sale = wp_travel_cart.cart.cart_items[item.dataset.cartId].trip_data.pricings[$('select[name="package"]').val()].categories[0].is_sale;
    alp_wptravel.pricing_id = wp_travel_cart.cart.cart_items[item.dataset.cartId].trip_data.pricings[$('select[name="package"]').val()].id;
    alp_wptravel.sale_price = wp_travel_cart.cart.cart_items[item.dataset.cartId].trip_data.pricings[$('select[name="package"]').val()].categories[0].sale_price;
    alp_wptravel.group_prices = wp_travel_cart.cart.cart_items[item.dataset.cartId].trip_data.pricings[$('select[name="package"]').val()].categories[0].group_prices;
    pax[wp_travel_cart.cart.cart_items[item.dataset.cartId].trip_data.pricings[$('select[name="package"]').val()].categories[0].id] = numofpeople;
    alp_wptravel.pax = pax;
    alp_wptravel.trip_id = wp_travel_cart.cart.cart_items[item.dataset.cartId].trip_id;
    alp_wptravel.arrival_date = wp_travel_cart.cart.cart_items[item.dataset.cartId].arrival_date;
    alp_wptravel.in_group_sale = false;
    alp_wptravel.has_coupon = false;
    //alp_wptravel.has_coupon = wp_travel_cart.cart.coupon.length;
    //pt.forEach(function(pc){

    //});
    //console.log('coupon: ' + alp_wptravel.has_coupon);
    console.log(Object.keys(alp_wptravel.group_prices).length);
    console.log(wp_travel_cart.cart.cart_items[item.dataset.cartId].trip_data);
    //console.log(wp_travel_cart.cart);
    if(Object.keys(alp_wptravel.group_prices).length > 0){
        for(var ct = 0; ct < Object.keys(alp_wptravel.group_prices).length; ct++ ){
          console.log('min' , alp_wptravel.group_prices[ct].min_pax);
          console.log('max' , alp_wptravel.group_prices[ct].max_pax);
          console.log('people' , numofpeople);
          if( parseInt(numofpeople) >= parseInt(alp_wptravel.group_prices[ct].min_pax) &&  parseInt(numofpeople) <= parseInt(alp_wptravel.group_prices[ct].max_pax)){
            console.log('ranged');
            console.log('ranged price', alp_wptravel.group_prices[ct].price);
            alp_wptravel.final_price = alp_wptravel.group_prices[ct].price;
            alp_wptravel.in_group_sale = true;
            console.log('finale price', alp_wptravel.final_price);
          }
      }
    }
    
    console.log(alp_wptravel);
    var html_price = '';
    if(alp_wptravel.is_sale || alp_wptravel.in_group_sale || alp_wptravel.has_coupon){
      html_price = '<del>' + wp_travel_cart.format(alp_wptravel.reg_price * numofpeople) + '</del>';
      if(alp_wptravel.hasOwnProperty('final_price')){
        alp_wptravel.sale_price = alp_wptravel.final_price;
      }
    }else{
      html_price = wp_travel_cart.format(alp_wptravel.reg_price * numofpeople);
    }

    if(wp_travel_cart.cart.coupon.hasOwnProperty('type')){
      console.log('coupon: ' + wp_travel_cart.cart.coupon.value);
      alp_wptravel.with_coupon_price = wp_travel_cart.format((alp_wptravel.reg_price * numofpeople) - wp_travel_cart.cart.coupon.value);
      alp_wptravel.has_coupon = true;
    }

    $('.normal-price-block .total-price').html(html_price);
    if(alp_wptravel.has_coupon && !alp_wptravel.in_group_sale){
      var x_cartTotal = 0;
      var x_coupon = wp_travel_cart.cart.coupon;
      var x_cValue = x_coupon.value && parseInt(x_coupon.value) || 0;
      var x_cart_value = alp_wptravel.reg_price * numofpeople;
      var x_coupon_money_value = x_coupon.type == 'fixed' ? x_cValue : x_cart_value - (x_cart_value * (100 - x_cValue) / 100);
      
      x_cartTotal = x_coupon.type == 'fixed' ? x_cart_value - x_cValue : x_cart_value * (100 - x_cValue) / 100;

      $('.today-price-block .today-price').html(wp_travel_cart.format((alp_wptravel.reg_price * numofpeople) - x_coupon_money_value));
      $('.saved-money-block .saved-money').html(wp_travel_cart.format((alp_wptravel.reg_price * numofpeople) -((alp_wptravel.reg_price * numofpeople) - x_coupon_money_value) ) + ' (' + ((((alp_wptravel.reg_price * numofpeople) - ((alp_wptravel.reg_price * numofpeople) - x_coupon_money_value)) / (alp_wptravel.reg_price * numofpeople)) * 100).toFixed(2) + '%)' );
      var final_html = '';
      final_html = wp_travel_cart.format((alp_wptravel.reg_price * numofpeople) - x_coupon_money_value);
      alp_wptravel.pay_price = (alp_wptravel.reg_price * numofpeople) - x_coupon_money_value; 
    }else if(alp_wptravel.is_sale || alp_wptravel.in_group_sale){
      console.log('group sale');
      $('.today-price-block').show();
      $('.saved-money-block').show();
      $('.today-price-block .today-price').html(wp_travel_cart.format(alp_wptravel.sale_price * numofpeople));
      $('.saved-money-block .saved-money').html(wp_travel_cart.format((alp_wptravel.reg_price * numofpeople) -(alp_wptravel.sale_price * numofpeople) ) + ' (' + ((((alp_wptravel.reg_price * numofpeople) - (alp_wptravel.sale_price * numofpeople)) / (alp_wptravel.reg_price * numofpeople)) * 100).toFixed(2) + '%)' );
      var final_html = '';
      final_html = wp_travel_cart.format(alp_wptravel.sale_price * numofpeople);
      alp_wptravel.pay_price = alp_wptravel.sale_price * numofpeople;
    }else{
      $('.today-price-block').hide();
      $('.saved-money-block').hide();
      $('.today-price-block .today-price').html(wp_travel_cart.format(alp_wptravel.regular_price * numofpeople));
      final_html = wp_travel_cart.format(alp_wptravel.reg_price * numofpeople);
      alp_wptravel.pay_price = alp_wptravel.reg_price * numofpeople;
    }
    $('.pay-now-block .pay-now > span').html(final_html);

    var _cartItems = document.querySelectorAll('[data-cart-id]');

    _cartItems && _cartItems.forEach(function (ci) {
      //console.log(ci);
      var totals = updateItem(ci.dataset.cartId);
      cartTotal += totals.tripTotal;
      tripTotalWOExtras += totals.tripTotalWOExtras;
      tripTotalPartialWOExtras += totals.tripTotalPartialWOExtras;
      txTotal += totals.extrasTotal;
    });
    if (cartSubtotalContainer) cartSubtotalContainer.innerHTML = wp_travel_cart.format(cartTotal); // let fullTotalContainer = e.target.querySelector('[data-wpt-cart-full-total]')

    if (wp_travel_cart.cart.coupon && wp_travel_cart.cart.coupon.coupon_id) {
      var coupon = wp_travel_cart.cart.coupon;

      var _cValue = coupon.value && parseInt(coupon.value) || 0; // fullTotalContainer.innerHTML = wp_travel_cart.format(cartTotal)


      if (cartDiscountContainer) {
        cartDiscountContainer.innerHTML = coupon.type == 'fixed' ? '- ' + wp_travel_cart.format(_cValue) : '- ' + wp_travel_cart.format(cartTotal * _cValue / 100);
        cartDiscountContainer.closest('[data-wpt-extra-field]').removeAttribute('style');
      }

      cartTotal = coupon.type == 'fixed' ? cartTotal - _cValue : cartTotal * (100 - _cValue) / 100;
    }

    if (wp_travel_cart.cart.total.discount <= 0) {
      // fullTotalContainer.innerHTML = ''
      cartDiscountContainer.closest('[data-wpt-extra-field]').style.display = 'none';
    }

    if (wp_travel_cart.cart.tax) {
      if (cartTaxContainer) cartTaxContainer.innerHTML = '+ ' + wp_travel_cart.format(cartTotal * parseInt(wp_travel_cart.cart.tax) / 100);
      cartTotal = cartTotal * (100 + parseInt(wp_travel_cart.cart.tax)) / 100;
    }

    if (cartTotalContainers) {
      cartTotalContainers.forEach(function (ctt) {
        return ctt.innerHTML = wp_travel_cart.format(cartTotal);
      });
    }

    if (cartTotalPartialContainers) {
      cartTotalPartialContainers.forEach(function (ctpc) {
        var _partialTotal = tripTotalPartialWOExtras + txTotal;

        if (wp_travel_cart.cart.tax) {
          _partialTotal = _partialTotal * (100 + parseFloat(wp_travel_cart.cart.tax)) / 100;
        }

        ctpc.innerHTML = wp_travel_cart.format(_partialTotal);
      });
    } // cartTotalContainer.innerHTML = wp_travel_cart.format(cartTotal)


    var cartItemsCountContainer = document.querySelector('[data-wpt-cart-item-count]');
    if (cartItemsCountContainer) cartItemsCountContainer.innerHTML = _cartItems.length;
  }
  if(jQuery('.trips-faq').length){
      setTimeout(function() { 
          jQuery('#faq__1').find('.trips-faq-question').trigger('click');
      },10);
      jQuery('.trips-faq .trips-faq-section .trips-faq-wrap .trips-faq-question').on('click', function(){
          jQuery(this).parent().toggleClass("expanded");
          jQuery(this).parent().find('.trips-faq-answer').slideToggle();
      });
  }
  if(jQuery('.services-faq').length){
    /*setTimeout(function() { 
        jQuery('#faq__1').find('.services-faq-question').trigger('click');
    },10);*/
    jQuery('.services-faq .services-faq-section .services-faq-wrap .services-faq-question').on('click', function(){
        jQuery(this).parent().toggleClass("expanded");
        jQuery(this).parent().find('.services-faq-answer').slideToggle();
    });
  }
});

var updateItem = function updateItem(id) {
  var shoppingCart = document.getElementById('shopping-cart');
  var _data = {};
  var tripTotalWOExtras = 0,
      tripTotalPartialWOExtras = 0,
      extrasTotal = 0;
  var tripTotal = 0;
  var item = wp_travel_cart.cart && wp_travel_cart.cart.cart_items && wp_travel_cart.cart.cart_items[id];
  var itemNode = shoppingCart.querySelector("[data-cart-id=\"".concat(id, "\"]"));
  var pricing = item.trip_data.pricings.find(function (p) {
    return p.id == parseInt(item.pricing_id);
  });
  var categories = pricing.categories;
  var _tripExtras = pricing.trip_extras;
  var wptCTotals = itemNode.querySelectorAll('[data-wpt-category-count]');
  var payoutPercentage = item.trip_data && item.trip_data.minimum_partial_payout_percent; // Categories.

  var formGroupsCategory = itemNode.querySelectorAll('[data-wpt-category]');
  formGroupsCategory.forEach(function (fg) {
    var categoryTotalContainer = fg.querySelector('[data-wpt-category-total]');
    var dataCategoryCount = fg.querySelector('[data-wpt-category-count-input]');
    var dataCategoryPrice = fg.querySelector('[data-wpt-category-price]');
    //console.log('price: ' + dataCategoryPrice);
    var _category = categories.find(function (c) {
      return c.id == parseInt(fg.dataset.wptCategory);
    });

    var _price = _category && _category.is_sale ? parseFloat(_category['sale_price']) : parseFloat(_category['regular_price']);

    var _count = dataCategoryCount && parseInt(dataCategoryCount.value) || 0;

    if (_category.has_group_price) {
      var _groupPrice = _category.group_prices.find(function (gp) {
        return _count >= parseInt(gp.min_pax) && _count <= parseInt(gp.max_pax);
      });

      _price = _groupPrice && _groupPrice.price || _price;
      if (dataCategoryPrice) dataCategoryPrice.innerHTML = wp_travel_cart.format(_price);
    }

    var categoryTotal = _category.price_per == 'group' ? _count > 0 && _price || 0 : _price * _count;
    wptCTotals && wptCTotals.forEach(function (wpct) {
      if (wpct.dataset.wptCategoryCount == fg.dataset.wptCategory) wpct.innerHTML = _count;
    });
    if (categoryTotalContainer) categoryTotalContainer.innerHTML = wp_travel_cart.format(categoryTotal);
    tripTotal += parseFloat(categoryTotal);
    tripTotalWOExtras += parseFloat(categoryTotal);
    tripTotalPartialWOExtras += parseFloat(categoryTotal) * parseFloat(payoutPercentage) / 100;
  }); // Extras.

  var formGroupsTx = itemNode.querySelectorAll('[data-wpt-tx]');
  formGroupsTx && formGroupsTx.forEach(function (tx) {
    var _extra = _tripExtras.find(function (c) {
      return c.id == parseInt(tx.dataset.wptTx);
    });

    if (!_extra.tour_extras_metas) {
      return;
    }

    var txTotalContainer = tx.querySelector('[data-wpt-tx-total]');
    var datatxCount = tx.querySelector('[data-wpt-tx-count-input]');

    var _price = _extra.is_sale && _extra.tour_extras_metas.extras_item_sale_price || _extra.tour_extras_metas.extras_item_price;

    var _count = datatxCount && datatxCount.value || 0;

    var itemTotal = parseFloat(_price) * parseInt(_count);
    if (txTotalContainer) txTotalContainer.innerHTML = wp_travel_cart.format(itemTotal);
    tripTotal += itemTotal;
    extrasTotal += itemTotal;
  });
  _data = {
    tripTotalWOExtras: tripTotalWOExtras,
    tripTotalPartialWOExtras: tripTotalPartialWOExtras,
    extrasTotal: extrasTotal,
    tripTotal: tripTotal
  };
  itemNode.querySelector('[data-wpt-item-total]').innerHTML = wp_travel_cart.format(tripTotal);
  return _data;
};


